import { render, staticRenderFns } from "./PlanRealData.vue?vue&type=template&id=c90a579c&lang=pug&"
import script from "./PlanRealData.vue?vue&type=script&lang=js&"
export * from "./PlanRealData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports